import { PostcodeAutocomplete } from './PostcodeAutocomplete';

export const showAutoCompletePostcodeSelector = store => ['AU', 'AU_SCA', 'AU_NRMA', 'NZ', 'NZ_SCA'].includes(store);

export default PostcodeAutocomplete;